export const attachmentSidebarText = {
  defaultUploadText: "Upload file (optional but recommended)",
  dragAndDropText: "Drag and drop files here, or",
  browseButtonText: "Browse my computer",
  pdfWarningMessage: "Please upload a PDF",
} as const;
